import { ROLE_ADMIN, ROLE_CLIENT, ROLE_DISTRIBUTOR } from "components/PermissionHandlers";

const SHOP_CODE = 'selectedShopCode';

/**
 * ? Description: The function below takes user permissions as an array of objects
 * ? and returns an array of strings contains only permissions that a user has access to
 * @param {*} userPerms 
 * @returns 
 */
export const mapPermissionsToArray = (userPerms = []) => {
  if (!userPerms?.length) return [];
  let newPerms = [];
  userPerms.forEach(perm => {
    if (perm.hasAccess) newPerms = [...newPerms, perm.permission];
  });
  return newPerms;
};

const getSelectedShopPermissions = (code, licences = []) => licences.find(({licenceCode}) => licenceCode === code);

export const getUserPermissions = (user) => {
  if (!user) return false;
  const {admin, distributor, client}  = user;
  if (admin) return {
    mainProfile: {
      role: ROLE_ADMIN,
      permissions: mapPermissionsToArray(user.adminProfile.permissions),
      isSuper: user.adminProfile.super
    },
    fallbackProfile: null
  };
  if (distributor && !client) return {
    mainProfile: {
      role: ROLE_DISTRIBUTOR,
      permissions: mapPermissionsToArray(user.distributorProfile.permissions),
      isSuper: user.distributorProfile.super
    },
    fallbackProfile: null
  };
  if (client) {
    const licence = getSelectedShopPermissions(localStorage.getItem(SHOP_CODE), user.licences);
    return {
      mainProfile: {
        role: ROLE_CLIENT,
        permissions: licence?.permissions ? mapPermissionsToArray(licence.permissions) : [],
        isSuper: licence?.super
      },
      fallbackProfile: distributor ? {
        role: ROLE_DISTRIBUTOR,
        permissions: user.distributorProfile.permissions || [],
        isSuper: user.distributorProfile.super,
      } : null
    };
  }
};
